import { AsyncPipe, DecimalPipe } from '@angular/common';
import { Component, HostBinding, OnInit, Type, inject } from '@angular/core';
import { Observable, catchError, combineLatest, of, shareReplay, switchMap, tap } from 'rxjs';
import { VisibleDirective, waitUntilVisible } from 'src/app/panels/directives/visible/visible.directive';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { IDurationKpiValue } from 'src/app/panels/models/kpi-value';
import { NumberPipe } from 'src/app/panels/pipes/number/number.pipe';
import { TimeSpanPipe } from 'src/app/panels/pipes/timespanToTime/time-span.pipe';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ErrorMessageComponent } from 'src/app/shared/components/error-message/error-message.component';
import { IDashboardParameters } from '../../../../dashboards/models/dashboard-parameters';
import { PanelService } from '../../../../dashboards/panels/services/panel/panel.service';
import { ColorService } from '../../../../shared/services/color/color.service';
import { Color } from '../../../../shared/services/color/colors';
import { PanelComponent } from '../../panel.component';

export const DURATION_KPI_PANEL_IMPORTS: Type<unknown>[] = [
  CardComponent,
  VisibleDirective,
  ErrorMessageComponent,
  AsyncPipe,
  DecimalPipe,
  NumberPipe,
  TimeSpanPipe,
];
@Component({
  selector: 'app-duration-kpi-panel',
  template: '',
})
export abstract class DurationKpiPanelComponent extends PanelComponent implements OnInit {
  @HostBinding('class') public class = 'col-12 col-md-6 col-lg-4 col-xl-3';

  public colorService = inject(ColorService);
  public color: Color = Color.Blue;
  public footerText$?: Observable<IDashboardParameters>;
  public duration: number | undefined;
  public infoText: string | undefined;

  public override data$?: Observable<IDurationKpiValue | null>;

  protected panelService = inject(PanelService);

  public abstract readonly unit?: DisplayUnit;
  public abstract override readonly icon?: string;

  ngOnInit(): void {
    this.footerText$ = this.dashboardParams$;
    this.data$ = combineLatest([this.dashboardParams$, this.visible$]).pipe(
      waitUntilVisible(this),
      switchMap((params) => {
        return this.panelService
          .getDurationKpi(this.getType(), this.entityIds, params.timeRange.from, params.timeRange.till)
          .pipe(
            catchError(() => {
              this.error = 'Geen data';
              return of(null);
            }),
          );
      }),
      tap((data) => {
        this.duration = data?.kpis.kpi.duration;
        this.infoText = data?.kpis.kpi.text;
        this.loading = false;
      }),
      shareReplay(1),
    );
  }
}
